
/* injects from baggage-loader */

'use strict';
import moment from 'moment';
import footerTpl from './footer.html';
import footerPartialTpl from '../../views/partials/footer.partial.html';

/**
 * Directive used for manipulate the HTML DOM elements inside the footer component,
 * the which is showed in the all application pages.
 *
 * @returns
 */
function footerComponent() {

	/**
	 * Directive definition.
	 */
	const directive = {
		restrict: 'E',
		templateUrl: footerTpl,
		controller: FooterController,
		controllerAs: 'footervm',
		bindToController: true
	};

	return directive;

	/**
	 * Controller used by directive for modified the values of the HTML DOM elements in your scope.
	 */
	function FooterController() {
		'ngInject';
		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		let vm = this;

		vm.currentDate = moment().format('YYYY');
		vm.footerPartialTpl = footerPartialTpl;
	}
}

export default footerComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/footer/footer.directive.js